/* jshint esversion: 6 */
import alertifyjs from '../../node_modules/alertifyjs/build/alertify.min.js';
import cordovaToast from '../cordova/toast.js';
import { Dialog } from '@capacitor/dialog';

require('../../node_modules/alertifyjs/build/css/alertify.min.css');

export default {
    message (text, options = {}, successCallback = null) {
        if (typeof successCallback !== 'function') {
            successCallback = function () { };
        }
        var defaultOptions = {
            duration: 2,
            position: 'center',
            estado: 'success'
        };
        if (!options) {
            options = {};
        }
        options = Object.assign(defaultOptions, options);
        if (process.env.CORDOVA) {
            if (options.duration) {
                options.duration = options.duration * 1000;
            }
            options.message = text;
            cordovaToast.toast(options, successCallback);
        } else {
            alertifyjs.notify(text, options.estado, options.duration, successCallback);
        }
    },
    async confirm (message, confirmCallback, title, buttonsLabel) {
        if (typeof confirmCallback !== 'function') {
            confirmCallback = function () { };
        }
        if (process.env.CORDOVA) {
            const { value } = await Dialog.confirm({
                title,
                message
            });
            confirmCallback(value ? 1 : 0);
        } else {
            // Default to browsers defaults
            if (window.confirm(message)) {
                confirmCallback(1);
            } else {
                confirmCallback(0);
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/services/dialogs.js